import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import "../App.css";

const InformacionPersonal = () => {
  const [formData, setFormData] = useState({
    // 1 - Datos
    tipoProveedor: "", // "Bienes" o "Servicios"
    razonSocial: "",
    cuit: "",
    nombreFantasia: "",
    correoElectronico: "",
    telefono: "",
    paginaWeb: "",

    // 2 - Domicilio Legal
    calle: "",
    numero: "",
    localidad: "",
    provincia: "",
    codigoPostal: "",

    // 3 - Representante Comercial
    nombreComercial: "",
    correoComercial: "",
    telefonoComercial: "",

    // 4 - Administración
    nombreAdministracion: "",
    correoAdministracion: "",
    telefonoAdministracion: "",

    // 5 - Gestor Documental
    nombreGestor: "",
    correoGestor: "",
    telefonoGestor: "",

    // 6 - Prevencionista
    nombrePrevencionista: "",
    registroPrevencionista: "",
    correoPrevencionista: "",

    // 7 - Rubro
    rubro: "",
    rubroOtro: "",

    // 8 - Certificaciones
    iso: "",

    // 9 - Proyecto
    codigoProyecto: ""
  });

  const [errores, setErrores] = useState({});
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [brochureFile, setBrochureFile] = useState(null);
  const [formTouched, setFormTouched] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);

  useEffect(() => {
    const fetchProveedor = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        const response = await fetch(`/api/get-proveedor?email=${user.email}`);
        const data = await response.json();
        const cuit = localStorage.getItem("cuit");

        if (data.proveedor && cuit) {
          setFormData((prev) => ({
            ...prev,
            razonSocial: data.proveedor,
            cuit,
          }));
        }
      } catch (error) {
        console.error("Error al cargar proveedor:", error);
      }
    };

    fetchProveedor();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormTouched(true);
  
    // Si se cambia a "Bienes", vaciar los campos de Gestor Documental y Prevencionista
    if (name === "tipoProveedor" && value === "Bienes") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        nombreGestor: "",
        correoGestor: "",
        telefonoGestor: "",
        nombrePrevencionista: "",
        registroPrevencionista: "",
        correoPrevencionista: ""
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };
  
  const getCamposObligatorios = () => {
    const baseCampos = [
      "tipoProveedor", "razonSocial", "cuit", "correoElectronico", "telefono",
      "calle", "numero", "localidad", "provincia", "codigoPostal",
      "nombreComercial", "correoComercial", "telefonoComercial",
      "nombreAdministracion", "correoAdministracion", "telefonoAdministracion"
    ];
  
    if (formData.tipoProveedor === "Servicios") {
      baseCampos.push("nombreGestor", "correoGestor", "telefonoGestor");
    }
  
    return baseCampos;
  };

  const validar = () => {
    const nuevosErrores = {};
    const camposObligatorios = getCamposObligatorios();
  
    camposObligatorios.forEach((campo) => {
      if (!formData[campo]) {
        nuevosErrores[campo] = "Este campo es obligatorio";
      }
    });
  
    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validar()) {
      alert("⚠️ Completá todos los campos obligatorios.");
      return;
    }
  
    const formDataToSend = new FormData();
    formDataToSend.append("data", JSON.stringify(formData));
    if (brochureFile) {
      formDataToSend.append("brochure", brochureFile);
    }
  
    try {
      const res = await fetch("/api/saveInformacionPersonal", {
        method: "POST",
        body: formDataToSend, // ✅ Usar el FormData armado
      });
  
      const result = await res.json();
      if (result.idRegistro) {
        localStorage.setItem("idRegistro", result.idRegistro);
      }
  
      setShowModal(true);
    } catch (error) {
      console.error("❌ Error al guardar:", error);
      alert("❌ Error al guardar la información.");
    }
  };
  
  const handleCerrarModal = () => {
    setShowModal(false);
    navigate("/gestionproveedoreshome");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBrochureFile(file);
    }
  };
  
  const renderCampo = (label, name, obligatorio = false, readOnly = false, type = "text", disabled = false, helperText = "") => (
    <div className="form-row-horizontal">
      <div className="label-column">
      <label htmlFor={name} style={{ color: disabled ? "#bbb" : "inherit" }}>
      {label}{obligatorio && " *"}
      </label>
      </div>
      <div className="input-column">
        <input
          id={name}
          name={name}
          type={type}
          className={`input-field ${errores[name] ? "error" : ""}`}
          value={formData[name]}
          onChange={handleChange}
          readOnly={readOnly}
          disabled={disabled}
          style={disabled ? { backgroundColor: "#f0f0f0", color: "#999" } : {}}
        />
        {disabled && helperText && (
          <div style={{ fontSize: "0.8em", color: "#888", marginTop: "3px" }}>{helperText}</div>
        )}
      </div>
    </div>
  );
  
  const renderSelect = (label, name, opciones = [], obligatorio = false) => (
    <div className="form-row-horizontal">
      <div className="label-column">
        <label htmlFor={name}>{label}{obligatorio && " *"}</label>
      </div>
      <div className="input-column">
        <select
          id={name}
          className="input-field"
          name={name}
          value={formData[name]}
          onChange={handleChange}
        >
          <option value="">Seleccione una opción</option>
          {opciones.map((opcion, index) => (
            <option key={index} value={opcion}>
              {opcion}
            </option>
          ))}
        </select>
      </div>
    </div>
  );

  const confirmBack = () => {
    setShowBackModal(false);
    navigate("/gestionproveedoreshome");
  };
  
  return (
    <div className="informacion-personal-container">
      <h2>Registro Proveedores de Bienes y Servicios</h2>
      <form onSubmit={handleSubmit} className="form-contenedor">
      {renderSelect("Tipo de Proveedor", "tipoProveedor", ["Bienes", "Servicios"], true)}
        <h3>1 - DATOS</h3>
        {renderCampo("Razón Social Proveedor", "razonSocial", true, true)}
        {renderCampo("CUIT", "cuit", true, true)}
        {renderCampo("Nombre Fantasía", "nombreFantasia")}
        {renderCampo("Correo Electrónico", "correoElectronico", true)}
        {renderCampo("Teléfono", "telefono", true)}
        {renderCampo("Página Web", "paginaWeb")}

        <h3>2 - DOMICILIO LEGAL</h3>
        {renderCampo("Calle / Avenida / Ruta", "calle", true)}
        {renderCampo("Número", "numero", true)}
        {renderCampo("Localidad", "localidad", true)}
        {renderCampo("Provincia", "provincia", true)}
        {renderCampo("Código Postal", "codigoPostal", true)}

        <h3>3 - REPRESENTANTE COMERCIAL</h3>
        {renderCampo("Nombre", "nombreComercial", true)}
        {renderCampo("Correo Electrónico", "correoComercial", true)}
        {renderCampo("Teléfono", "telefonoComercial", true)}

        <h3>4 - ADMINISTRACIÓN</h3>
        {renderCampo("Nombre", "nombreAdministracion", true)}
        {renderCampo("Correo Electrónico", "correoAdministracion", true)}
        {renderCampo("Teléfono", "telefonoAdministracion", true)}

        <h3>5 - GESTOR DOCUMENTAL</h3>
        {renderCampo("Nombre Gestor Documental", "nombreGestor", formData.tipoProveedor === "Servicios", false, "text", formData.tipoProveedor === "Bienes", "No requerido para proveedores de bienes")}
        {renderCampo("Correo Electrónico Gestor Documental", "correoGestor", formData.tipoProveedor === "Servicios", false, "text", formData.tipoProveedor === "Bienes", "No requerido para proveedores de bienes")}
        {renderCampo("Tel. Cel Responsable Gestor Documental", "telefonoGestor", formData.tipoProveedor === "Servicios", false, "text", formData.tipoProveedor === "Bienes", "No requerido para proveedores de bienes")}

        <h3>6 - PREVENCIONISTA</h3>
        {renderCampo("Nombre Prevencionista", "nombrePrevencionista", false, false, "text", formData.tipoProveedor === "Bienes", "No requerido para proveedores de bienes")}
        {renderCampo("N° Registro Prevencionista", "registroPrevencionista", false, false, "text", formData.tipoProveedor === "Bienes", "No requerido para proveedores de bienes")}
        {renderCampo("Correo Electrónico Prevencionista", "correoPrevencionista", false, false, "text", formData.tipoProveedor === "Bienes", "No requerido para proveedores de bienes")}

        <h3>7 - RUBRO</h3>
        {renderSelect("Rubro / Servicio", "rubro", ["Articulos eléctricos / eléctronicos", "Bulonería / Metales", "Calibración / Certificación de equipos", "Conductores", "Contenedores / Módulos / Trailers",
                                                    "Equipamiento de playa", "Ferretería / Construcción", "Herrajes / Morsetería / Estructuras", "Hormigón (Provisión, estructuras)",
                                                    "Indumentaria / EPP", "IT: Equipamiento informático, telefonía, redes", "Maquinaria, vehículos (Venta / Alquiler)",
                                                    "Servicio de mantenimiento general / limpieza", "Servicio de encomiendas y/o transporte", "Servicio de Ingeniería", "Servicio médico y/o laboratorio",
                                                    "Venta de equipos especializados", "Otros (Especifique)"])}
        {formData.rubro === "Otros (Especifique)" && renderCampo("Otro rubro", "rubroOtro")}

        <h3>8 - CERTIFICACIONES</h3>
        {renderSelect("¿Cuenta con certificación ISO?", "iso", ["Sí", "No"])}

        <h3>9 - PROYECTO</h3>
        {renderCampo("Código Proyecto (SAP)", "codigoProyecto", formData.tipoProveedor === "Servicios", false, "text", formData.tipoProveedor === "Bienes", "No requerido para proveedores de bienes")}

        <h3>10 - BROCHURE INSTITUCIONAL</h3>
        <div className="form-row-horizontal">
          <div className="label-column">
            <label htmlFor="brochure">Adjuntar Brochure (PDF)</label>
          </div>
          <div className="input-column">
            <input
              type="file"
              accept="application/pdf"
              id="brochure"
              onChange={handleFileChange}
              className="input-field"
            />
          </div>
        </div>

        <div className="button-container">
          <button
            className="secondary-button"
            type="button"
            onClick={() => {
              if (formTouched) setShowBackModal(true);
              else navigate("/gestionproveedoreshome");
            }}
          >
            Volver
          </button>
          <button className="primary-button" type="submit">
            Enviar
          </button>
        </div>
      </form>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="check-icon">✔️</div>
            <p>Información cargada correctamente.</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={handleCerrarModal}>Aceptar</button>
            </div>
          </div>
        </div>
      )}
      {showBackModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="warning-icon">⚠️</div>
            <p>¿Deseás volver? Se perderán los datos ingresados.</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={confirmBack}>Sí, volver</button>
              <button className="no-btn" onClick={() => setShowBackModal(false)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InformacionPersonal;




